module.exports = __webpack_public_path__ + "media/images/icons/close-4e3c8db64aba521fb7ccc72647e878ce.svg";